import {
  Component,
  forwardRef,
  inject,
  input,
  OnInit,
  DestroyRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { PortalConfig, PortalCredential } from '@ui/shared/model';
import {
  FormBuilder,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';

import { AppInputDirective } from '../../../components/legacy/form/controls/input/input.directive';
import { FormFieldComponent } from '../../../components/legacy/form/form-field/form-field.component';
import { FormFieldLabelComponent } from '../../../components/legacy/form/form-field/form-field-label/form-field-label.component';
import { CredentialValidatorService } from '../../services/credential-validator.service';
import { BasePortalCredentialControl } from '../../controls/base-portal-credential.control';

@Component({
  selector: 'app-portal-credential-details-with-provider',
  templateUrl: './portal-credential-details-with-provider.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(
        () => PortalCredentialDetailsWithProviderComponent
      ),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FormFieldLabelComponent,
    FormFieldComponent,
    AppInputDirective
  ]
})
export class PortalCredentialDetailsWithProviderComponent
  extends BasePortalCredentialControl
  implements OnInit
{
  #destroyRef = inject(DestroyRef);
  private fb = inject(FormBuilder);
  private credentialValidatorService = inject(CredentialValidatorService);

  public readonly portalConfig = input<PortalConfig>(undefined);
  public readonly credential = input<PortalCredential>(undefined);

  constructor() {
    super();

    this.form = this.fb.group({
      name: ['', Validators.required],
      properties: this.fb.group({
        username: ['', Validators.required],
        password: ['', Validators.required],
        providerNumber: ['', Validators.required]
      })
    });
  }

  public ngOnInit() {
    const credentialValue = this.credential();
    if (credentialValue) {
      this.form.patchValue(credentialValue);
    }

    this.form.valueChanges.subscribe(credential => {
      this.value = { ...credential };

      this.onChange(this.value);
      this.onTouch();
    });

    this.credentialValidatorService.validationError$
      .pipe(
        filter(portal => !!portal),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(portal =>
        this.setCredentialValidationError(
          this.portalConfig().validationControl || 'password',
          portal === this.credential().portal
        )
      );
  }
}
